import type { Agent } from '@orqforge/shared';

export interface CollaborateEntryModel {
  defaultAgent: Agent | null;
  directAgents: Agent[];
  selectableAgents: Agent[];
  emptyStateTitle: string;
}

export function buildCollaborateEntryModel(agents: Agent[]): CollaborateEntryModel {
  const available = agents
    .filter((agent) => agent.status === 'active')
    .sort((a, b) => a.tier - b.tier || a.name.localeCompare(b.name));
  const defaultAgent =
    available.find((agent) => agent.agentRole === 'orchestrator') ??
    available[0] ??
    null;

  return {
    defaultAgent,
    directAgents: available.filter((agent) => agent.id !== defaultAgent?.id),
    selectableAgents: defaultAgent
      ? [defaultAgent, ...available.filter((agent) => agent.id !== defaultAgent.id)]
      : [],
    emptyStateTitle: 'Start with the main intake',
  };
}

export function findSelectedAgent(agents: Agent[], agentId: string): Agent | null {
  return agents.find((agent) => agent.id === agentId) ?? null;
}
